import { ref } from 'vue'

export interface LocationOption {
  value: string
  label: string
}

// public/json/countries.json and states.json map codes to names. Loaded once
// per page session and shared by every address form.
const countries = ref<LocationOption[]>([])
const states = ref<LocationOption[]>([])
let loading: Promise<void> | null = null

const toOptions = (map: Record<string, string>): LocationOption[] =>
  Object.entries(map).map(([value, label]) => ({ value, label }))

/** Country and US state options for address fields. */
export function useLocationOptions() {
  if (!loading) {
    loading = Promise.all([
      $fetch<Record<string, string>>('/json/countries.json'),
      $fetch<Record<string, string>>('/json/states.json'),
    ])
      .then(([countryMap, stateMap]) => {
        countries.value = toOptions(countryMap)
        states.value = toOptions(stateMap)
      })
      .catch((error) => {
        console.error('Could not load country and state lists:', error)
        loading = null
      })
  }
  return { countries, states }
}
